// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"16":"54c614cb","171":"6d6724e5","856":"6d6724e5"}[chunkId] + ".chunk.css";
};